import "./release-update-banner.css";

type ReleaseUpdateBannerProps = {
  isVisible: boolean;
  onReload?: () => void;
};

export function ReleaseUpdateBanner({
  isVisible,
  onReload = () => window.location.reload(),
}: ReleaseUpdateBannerProps) {
  if (!isVisible) {
    return null;
  }

  return (
    <aside className="release-update-banner" role="status" aria-live="polite">
      <p>
        <strong>Update ready.</strong>
        <span>Reload to use the latest version.</span>
      </p>
      <button type="button" onClick={onReload}>
        Reload now
      </button>
    </aside>
  );
}
